<!--工作室详情-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="er-page">
            <!--标签页：概况/工作室查询/工作室成果/工作室咨询-->
            <div class="tab-row">
                <studio-menu :item-num="this.activeItem"
                             @change-item="jumpStudio"/>
            </div>
            <div class="module-content">
                <!-- 工作室详情导航-->
                <div class="nav_container">
                    <div class="nav-box">
                        <ul>
                            <li><a @click="changeActiveNum(0)" :class="activeNum===0?'is_active':''">首页</a></li>
                            <li><a @click="changeActiveNum(1)" :class="activeNum===1?'is_active':''">简介</a></li>
<!--                            <li><a @click="changeActiveNum(2)" :class="activeNum===2?'is_active':''">公告资讯</a></li>-->
                            <li><a @click="changeActiveNum(3)" :class="activeNum===3?'is_active':''">成果展示</a></li>
                            <li><a @click="changeActiveNum(4)" :class="activeNum===4?'is_active':''">教师文章</a></li>
                            <li><a @click="changeActiveNum(5)" :class="activeNum===5?'is_active':''">高水平示范课</a></li>
                            <li><a @click="changeActiveNum(7)" :class="activeNum===7?'is_active':''">区本课程</a></li>
                            <li><a @click="changeActiveNum(8)" :class="activeNum===8?'is_active':''">校本课程</a></li>
                            <li><a @click="changeActiveNum(6)" :class="activeNum===6?'is_active':''">工作日志</a></li>
                        </ul>
                    </div>
                </div>
                <div class="info-container">
                    <!-- 首页 -->
                    <detail-home v-show="activeNum===0"
                                 :studio-id="studioId"
                                 @change-nav-active="changeActiveNum"
                                 @view-studio-info-active="viewStudioInfo"/>
                    <!-- 简介 -->
                    <brief-introduction  v-show="activeNum===1"
                                         :studio-id="studioId"/>
                    <!-- 公告资讯 -->
                    <notice-news v-show="activeNum===2"
                                 :studio-id="studioId" />
                    <!-- 成果展示 -->
                    <studio-achievement v-show="activeNum===3"
                                        :studio-id="studioId"
                                        :achieve-mode="this.achieveMode"
                                        :parent-id="this.achieveId"
                                        @change-mode="changeMode"/>
                    <!-- 教师文章 -->
                    <studio-article v-show="activeNum===4"
                                    :studio-id="studioId"
                                    :achieve-mode="this.articleMode"
                                    :parent-id="this.articleId"
                                    @change-mode="changeMode"/>
                    <!-- 高水平示范课 -->
                    <studio-course v-show="activeNum===5"
                                   title="高水平示范课"
                                   courseType="1"
                                   :studio-id="studioId"
                                   :course-mode="this.courseMode"
                                   :parent-id="this.courseId"
                                   @change-mode="changeMode"/>
                    <!-- 区本课程 -->
                    <studio-course-qb v-show="activeNum===7"
                                   title="区本课程"
                                   courseType="2"
                                   :studio-id="studioId"
                                   :course-mode="this.qbCourseMode"
                                   :parent-id="this.qbCourseId"
                                   @change-mode="changeMode"/>
                    <!-- 校本课程 -->
                    <studio-course-xb v-show="activeNum===8"
                                   title="校本课程"
                                   courseType="3"
                                   :studio-id="studioId"
                                   :course-mode="this.xbCourseMode"
                                   :parent-id="this.xbCourseId"
                                   @change-mode="changeMode"/>
                    <!-- 工作日志 -->
                    <studio-log v-show="activeNum===6"
                                :studio-id="studioId"
                                :achieve-mode="this.logMode"
                                :parent-id="this.logId"
                                @change-mode="changeMode"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import homeFooter from "@/components/homeFooter";
import dataEmpty from "@/components/dataEmpty.vue";
import detailHome from "@/components/studioDetail/detailHome";
import briefIntroduction from "@/components/studioDetail/briefIntroduction.vue";
import noticeNews from "@/components/studioDetail/noticeNews.vue";
import studioAchievement from "@/components/studioDetail/studioAchievement";
import studioArticle from "@/components/studioDetail/studioArticle.vue";
import studioLog from "@/components/studioDetail/studioLog.vue";
import studioCourse from "@/components/studioDetail/studioCourse.vue";
import studioCourseQb from "@/components/studioDetail/studioCourseQb.vue";
import studioCourseXb from "@/components/studioDetail/studioCourseXb.vue";
import studioMenu from "@/components/studio/studioMenu.vue";
export default {
    components: {
        dataEmpty,
        homeHead,
        homeFooter,
        detailHome,
        briefIntroduction,
        noticeNews,
        studioAchievement,
        studioArticle,
        studioLog,
        studioCourse,
        studioCourseQb,
        studioCourseXb,
        studioMenu
    },
    name: "homeStudioDetail",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activeNum: 0,
            activePath: "",
            activeItem:"1",
            studioId :'',
            studioNature:'',
            isStudioPeopleList: false,
            studioPeopleList: [],
            studioTitle: '',
            studioClassifyList: [],
            achieveId:'',
            achieveMode:'page',
            articleId:'',
            articleMode:'page',
            logId:'',
            logMode:'page',
            courseId:'',
            courseMode:'page',
            qbCourseId:'',
            qbCourseMode:'page',
            xbCourseId:'',
            xbCourseMode:'page',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.activePath = this.$store.state.params.jumpParams.activePath;
        this.activeItem = this.$store.state.params.jumpParams.activeItem;
        this.studioId = this.$store.state.params.jumpParams.studioId;
        this.studioNature = this.$store.state.params.jumpParams.studioNature;
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        jumpStudio(item){
            let jumpPath = '/jzedu/teastudio';
            if (this.studioNature==='3'){
                jumpPath = '/jzedu/rectorstudio';
            }
            //参数传递
            this.$store.commit("params/setJumpParams", {activePath:this.activePath,activeItem: item});
            this.$router.push({path: jumpPath});
        },
        changeActiveNum(i) {
            this.activeNum = i;
            if (i===3){
                this.achieveMode = this.pageMode;
            }
            if (i===4){
                this.articleMode = this.pageMode;
            }
            if (i===5){
                this.courseMode = this.pageMode;
            }
            if (i===6){
                this.logMode = this.pageMode;
            }
            if (i===7){
                this.qbCourseMode = this.pageMode;
            }
            if (i===8){
                this.xbCourseMode = this.pageMode;
            }

        },
        viewStudioInfo(infoId,i){
            this.activeNum = i;
            //成果
            if (i===3){
                this.achieveId = infoId;
                this.achieveMode = this.detailMode;
            }
            //文章
            if (i===4){
                this.articleId= infoId;
                this.articleMode = this.detailMode;
            }
            //高水平示范课
            if (i===5){
                this.courseId= infoId;
                this.courseMode = this.detailMode;
            }
            //区本课程
            if (i==7){
                this.qbCourseId= infoId;
                this.qbCourseMode = this.detailMode;
            }
            //校本课程
            if (i===8){
                this.xbCourseId= infoId;
                this.xbCourseMode = this.detailMode;
            }
            //日志
            if (i===6){
                this.logId= infoId;
                this.logMode = this.detailMode;
            }
        },
        changeMode(mode,i){
            if (i===3){
                this.achieveMode = mode;
            }
            if (i===4){
                this.articleMode = mode;
            }
            if (i===5){
                this.courseMode = mode;
            }
            if (i===6){
                this.logMode = mode;
            }
            if (i===7){
                this.qbCourseMode = mode;
            }
            if (i===8){
                this.xbCourseMode = mode;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.er-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}
/*标签页*/
.tab-row {
    display: flex;
    align-items: center;
    gap: 16px;
    max-width: 1840px;
    margin: 0 auto 24px;
}
.module-content {
    max-width: 1840px;
    margin: 0 auto;
    min-height: calc(100vh - 182px);
    box-sizing: border-box;
}
/*详情导航*/
.nav_container {
    width: 100%;
    height: 48px;
    background: #fff;
    border-radius: 16px;
    margin-bottom: 16px;
}
.nav-box{
    width: fit-content;
    height: 48px;
    margin: auto;
}
.nav-box ul{
    display: flex;
    width: fit-content;
    height: 48px!important;
    padding-inline-start: 0!important;
    margin: 0;
}
.nav-box ul li {
    position: relative;
    float: left;
    width: auto;
    text-align: center;
    line-height: 48px;
    list-style-type: none;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
}
.nav-box ul li a {
    color: #333;
    display: block;
    cursor: pointer;
    font-size: 16px;
}
.nav-box ul li a:hover{
    color: #ff7f2e;
    font-weight: bold;
}
.is_active{
    font-weight: bold;
    color: #ff7f2e!important;
}
/*主要内容*/
.info-container{
    width: 100%;
    height: auto;
}
</style>